import React from 'react';

import TemplateBuilder from './TemplateBuilder';

export default props => (
  <React.Fragment>
    <TemplateBuilder
      mode="show"
      templateId={props.id}
    />
  </React.Fragment>
);



// WEBPACK FOOTER //
// ./src/components/EmailTemplates/Show.js